import { echartLineTitol, echartLineLinia } from './common';

export function echartUsuarisPerTitolLineMonth(vis, datos) {
  echartLineTitol(
    'chartUsuarisTitolLineMonth',
    'no_dataUsuarisTitolLineMonth',
    datos.resultset,
    "ÚS D'EMT. USUARIS PER TÍTOL: HISTÒRIC MENSUAL",
    true,
  );
}

export function echartUsuarisPerLiniaLineMonth(vis, datos) {
  echartLineLinia(
    'chartUsuarisLiniaLineMonth',
    'no_dataUsuarisLiniaLineMonth',
    datos.resultset,
    "ÚS D'EMT. USUARIS PER LÍNIA: HISTÒRIC MENSUAL",
    true,
  );
}
